import posthog from 'posthog-js';

const API_KEY = import.meta.env.VITE_POSTHOG_API_KEY || '';
const HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com';

const POSTHOG_OPTIONS = {
    api_host: HOST,
    defaults: '2026-05-30' as const,
    person_profiles: 'identified_only' as const,
    capture_pageview: true,
    capture_pageleave: true,
    session_recording: {
        maskAllInputs: true,
        sampleRate: 0.2,
    },
};

export function isPostHogEnabled(): boolean {
    return Boolean(API_KEY);
}

export function initPostHog(app: string): void {
    if (!API_KEY) {
        return;
    }

    posthog.init(API_KEY, {
        ...POSTHOG_OPTIONS,
        loaded: (client) => {
            client.register({
                app,
                environment: import.meta.env.MODE,
            });
        },
    });
}

export function identifyPostHogUser(user?: {_id?: string; email?: string; username?: string} | null): void {
    if (!API_KEY) {
        return;
    }

    if (!user?._id) {
        posthog.reset();
        return;
    }

    posthog.identify(user._id, {
        email: user.email,
        username: user.username,
    });
}

export {posthog};
